module.exports = "/10edfd4068d34c50b2112484a9ac70e4d00b19fd/475396997e3882d510b3437585c5014b.svg";